<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="kreditgenie-text-green hover:kreditgenie-text-green-hover" :href="route('users')">Benutzer</inertia-link>
      <span class="kreditgenie-text-green font-medium">/</span> Erschaffen
    </h1>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.first_name" :error="form.errors.first_name" class="pr-6 pb-8 w-full lg:w-1/2" label="Vorname" />
          <text-input v-model="form.last_name" :error="form.errors.last_name" class="pr-6 pb-8 w-full lg:w-1/2" label="Nachname" />
          <text-input v-model="form.email" :error="form.errors.email" class="pr-6 pb-8 w-full lg:w-1/2" label="Email" />
          <text-input v-model="form.password" :error="form.errors.password" class="pr-6 pb-8 w-full lg:w-1/2" type="password" autocomplete="new-password" label="Passwort" />
          <textarea-input v-model="form.bio" :error="form.errors.bio" class="pr-6 pb-8 w-full" label="Bio" />
          <select-input v-model="form.owner" :error="form.errors.owner" class="pr-6 pb-8 w-full lg:w-1/2" label="Eigentümer">
            <option :value="true">Yes</option>
            <option :value="false">No</option>
          </select-input>
          <file-input v-model="form.photo" :error="form.errors.photo" class="pr-6 pb-8 w-full lg:w-1/2" type="file" accept="image/*" label="Foto" />
          <select-input v-model="form.is_on_homepage" :error="form.errors.is_on_homepage" class="pr-6 pb-8 w-full lg:w-1/2" label="Auf der Startseite anzeigen?">
            <option :value="true">Ja</option>
            <option :value="false">Nein</option>
          </select-input>
          <select-input v-model="form.user_function" :error="form.errors.is_on_homepage" class="pr-6 pb-8 w-full lg:w-1/2" label="Benutzerfunktion?">
            <option v-for="functionItem in userFunctions" :key="functionItem" :value="functionItem">
              {{ functionItem }}
            </option>
          </select-input>
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
          <loading-button :loading="form.processing" class="btn-green" type="submit">Erschaffen</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import FileInput from '@/Shared/FileInput'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TextareaInput from '../../Shared/TextareaInput'

export default {
  metaInfo: { title: 'Benutzer Erschaffen' },
  components: {
    TextareaInput,
    FileInput,
    LoadingButton,
    SelectInput,
    TextInput,
  },
  layout: Layout,
  props: {
    userFunctions: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        first_name: null,
        last_name: null,
        email: null,
        password: null,
        owner: false,
        photo: null,
        bio: null,
        is_on_homepage: false,
        user_function: null,
      }),
    }
  },
  methods: {
    store() {
      this.form.post(this.route('users.store').url())
    },
  },
}
</script>
